import { InventoryItemOutcome } from "@redotech/crdb-enums/inventory/inventory-item-outcome";
import { ALWAYS_SUPPORTED_OUTCOMES } from "../returns-center-outcomes";

/** Outcomes an item can still move on from; every other outcome is terminal. */
export const TEMPORARY_OUTCOMES: readonly InventoryItemOutcome[] = [
  InventoryItemOutcome.Restock,
];

function isTemporaryOutcome(outcome: InventoryItemOutcome): boolean {
  return TEMPORARY_OUTCOMES.includes(outcome);
}

export function isTerminalOutcome(
  outcome: InventoryItemOutcome | null,
): boolean {
  return outcome !== null && !isTemporaryOutcome(outcome);
}

/** Only shipping sets these; a rule can never assign them. */
export const UNASSIGNABLE_OUTCOMES: readonly InventoryItemOutcome[] = [
  InventoryItemOutcome.Fulfilled,
];

/**
 * The outcomes a location supports: every outcome at a location that isn't a
 * returns center, else the center's stored `supported_outcomes` plus the ones
 * every center supports.
 */
export function supportedOutcomesAtLocation(
  returnsCenterId: bigint | null,
  storedSupportedOutcomes: readonly InventoryItemOutcome[],
): ReadonlySet<InventoryItemOutcome> {
  if (returnsCenterId === null) {
    return new Set(Object.values(InventoryItemOutcome));
  }
  return new Set([...ALWAYS_SUPPORTED_OUTCOMES, ...storedSupportedOutcomes]);
}
